import CommonMiddleware from 'yoda-site-components/lib/middlewares/CommonMiddleware';
import AccountComponentsMiddleware from 'yoda-account-components/lib/middlewares/AccountComponentsMiddleware';
import AccountAnalyticsMiddleware from './AccountAnalyticsMiddleware';

const rootMiddleware = [CommonMiddleware, AccountAnalyticsMiddleware, AccountComponentsMiddleware];

export default rootMiddleware;
